import { render, staticRenderFns } from "./IntroText.vue?vue&type=template&id=0eb06e68&"
import script from "./IntroText.vue?vue&type=script&lang=js&"
export * from "./IntroText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports